import { subscriptionConstants } from "@/actions/constants/subscriptionConstants";
import { request, success, failure } from "@/utils/constants";

const initialState = {
    plans: [],
    loading: false,
    error: null,
};

export const subscriptionPlanList = (
    state = initialState,
    action: any
) => {

    switch (action.type) {
        case subscriptionConstants.GET_SUBSCRIPTION_PLANS_REQUEST:
            return {
                ...request,
                plans: [],
            };

        case subscriptionConstants.GET_SUBSCRIPTION_PLANS_SUCCESS:
            return {
                ...success,
                plans: action.payload,
            };

        case subscriptionConstants.GET_SUBSCRIPTION_PLANS_FAILURE:
            return {
                ...failure,
            };

        default:
            return state;
    }
};

export const subscriptionSummary = (
    state = initialState,
    action: any
) => {
    switch (action.type) {

        case subscriptionConstants.GET_SUBSCRIPTION_SUMMARY_REQUEST:
            return {
                ...request,
            };

        case subscriptionConstants.GET_SUBSCRIPTION_SUMMARY_SUCCESS:
            return {
                ...success,
                subscription: action?.payload,
            };
        case subscriptionConstants.GET_SUBSCRIPTION_SUMMARY_FAILURE:
            return {
                ...failure,
            };

        default:
            return state;
    }
};

export const viewSubscription = (state = initialState, action: any) => {
    switch (action.type) {
        case subscriptionConstants.viewSubscriptionRequest:
            return {
                ...request,
            };
        case subscriptionConstants.viewSubscriptionSuccess:
            return {
                ...success,
                subscription: action.payload,
            };
        case subscriptionConstants.viewSubscriptionFailure:
            return {
                ...failure,
            };
        default:
            return state;
    }
}

export const subscriptionHistory = (
    state = initialState,
    action: any
) => {
    switch (action.type) {

        case subscriptionConstants.GET_SUBSCRIPTION_PAYMENTS_REQUEST:
            return {
                ...request,
            };

        case subscriptionConstants.GET_SUBSCRIPTION_PAYMENTS_SUCCESS:
            return {
                ...success,
                history: action.payload,
            };

        case subscriptionConstants.GET_SUBSCRIPTION_PAYMENTS_FAILURE:
            return {
                ...failure,
            };

        default:
            return state;
    }
};

export const prepareSubscriptionCheckout = (
    state = initialState,
    action: any
) => {
    switch (action.type) {

        case subscriptionConstants.prepareSubscriptionCheckoutRequest:
            return {
                ...request,
            };

        case subscriptionConstants.prepareSubscriptionCheckoutSuccess:
            return {
                ...success,
                subscription: action.payload,
            };
        case subscriptionConstants.prepareSubscriptionCheckoutFailure:
            return {
                ...failure,
            };

        default:
            return state;
    }
};


export const updateSubscription = (state = initialState, action: any) => {
    switch (action.type) {
        case subscriptionConstants.updateSubscriptionRequest:
            return {
                ...request,
            };
        case subscriptionConstants.updateSubscriptionSuccess:
            return {
                ...success,
                subscription: action.payload,
            };
        case subscriptionConstants.updateSubscriptionFailure:
            return {
                ...failure,
            };
        default:
            return state;
    }
}



export const verifySubscriptionPayment = (
    state = initialState,
    action: any
) => {

    switch (action.type) {

        case subscriptionConstants.verifySubscriptionPaymentRequest:
            return {
                ...request,
            };

        case subscriptionConstants.verifySubscriptionPaymentSuccess:
            return {
                ...success,
                payment: action.payload,
            };

        case subscriptionConstants.verifySubscriptionPaymentFailure:
            return {
                ...failure,
                error: action.payload,
            };

        default:
            return state;

    }

};

export const cancelSubscription = (
    state = initialState,
    action: any
) => {
    switch (action.type) {

        case subscriptionConstants.cancelSubscriptionRequest:
            return {
                ...request,
            };

        case subscriptionConstants.cancelSubscriptionSuccess:
            return {
                ...success,
                subscription: action.payload,
            };

        case subscriptionConstants.cancelSubscriptionFailure:
            return {
                ...failure,
                error: action.payload,
            };

        default:
            return state;

    }

};

export const checkSubscriptionStatus = (
    state = initialState,
    action: any
) => {
    switch (action.type) {
        case subscriptionConstants.checkSubscriptionStatusRequest:
            return {
                ...request,
            };
        case subscriptionConstants.checkSubscriptionStatusSuccess:
            return {
                ...success,
                subscriptionStatus: action.payload,
            };
        case subscriptionConstants.checkSubscriptionStatusFailure:
            return {
                ...failure,
                error: action.payload,
            };
        default:
            return state;
    }
}

